export type SessionFaultKind = "expired";

function isSessionRefusedStatus(status: number): boolean {
  return status === 401 || status === 403;
}

export function isReadUnavailableStatus(status: number): boolean {
  return isSessionRefusedStatus(status) || status >= 500;
}

export function sessionFaultI18nKey(kind: SessionFaultKind): string {
  return `sessionFault.${kind}`;
}
